/* 

  HEADS UP! THIS IS A GENERATED FILE!
  
  Changes done in this file will be overwritten on next generation from the code generator.

*/
import axios from 'axios';
import { arrayMerge } from 'flaivy-react/utils/array-helper';
import _ from 'lodash';
import getAxiosInstance from '../../../config/api';
import datalayer from '../../../datalayer';

export const ACTION_TYPES = {
  UPSERT_END_CUSTOMER_IN_INVENTORY:
    'END_CUSTOMER_IN_INVENTORY/UPSERT_END_CUSTOMER_IN_INVENTORY',
  UPSERT_WHEN_EMPTY_END_CUSTOMER_IN_INVENTORY:
    'END_CUSTOMER_IN_INVENTORY/UPSERT_WHEN_EMPTY_END_CUSTOMER_IN_INVENTORY',
  UPDATE_WHEN_EMPTY_END_CUSTOMER_IN_INVENTORY:
    'END_CUSTOMER_IN_INVENTORY/UPDATE_WHEN_EMPTY_END_CUSTOMER_IN_INVENTORY',
  UPDATE_END_CUSTOMER_IN_INVENTORY:
    'END_CUSTOMER_IN_INVENTORY/UPDATE_END_CUSTOMER_IN_INVENTORY',
  FETCH_END_CUSTOMER_IN_INVENTORY:
    'END_CUSTOMER_IN_INVENTORY/FETCH_END_CUSTOMER_IN_INVENTORY',
  SET_END_CUSTOMER_IN_INVENTORY_LIST: 'SET_END_CUSTOMER_IN_INVENTORY_LIST',
};

let cancelTokenSource = null;

export async function fetchMoreAndReturnNewState(newQuery, state, req) {
  const { entities, currentPage, hasMore, sort } = state;

  if (cancelTokenSource) {
    cancelTokenSource.cancel();
  }

  const page = currentPage + 1;

  if (!hasMore && page !== 1) return state;

  cancelTokenSource = axios.CancelToken.source();
  const query = { query: newQuery, page, sort, searchString: state.search };
  const options = { cancelToken: cancelTokenSource.token };
  const responseData = await datalayer.endCustomerInInventory.list(
    query,
    req,
    options,
  );
  if (responseData === undefined) {
    //canceled request
    return undefined;
  }

  cancelTokenSource = null;
  const recievedEntities = responseData.rows;
  const newHasMore = responseData.page < responseData.totalPages;
  let newEntities = [];
  if (responseData.page === 1) {
    newEntities = recievedEntities;
  } else {
    newEntities = arrayMerge(recievedEntities, entities);
  }
  return {
    query: newQuery,
    hasMore: newHasMore,
    total: responseData.total,
    entities: newEntities,
    currentPage: responseData.page,
    search: state.search,
    sort: _.get(newQuery, 'sort', sort),
  };
}

export const refreshListOnQueryDiff =
  (newListState, req) => async (dispatch, getState) => {
    let payload = newListState;
    const currentState = _.get(getState(), 'endCustomerInInventoryList');
    const currentQuery = currentState.query;
    if (!_.isEqual(newListState.query, currentQuery)) {
      payload = await fetchMoreAndReturnNewState(
        newListState.query,
        { ...currentState, ...newListState, currentPage: 0 },
        req,
      );
    }
    if (!payload) {
      return;
    } // cancelled loading, dont update the store
    await dispatch({
      type: ACTION_TYPES.SET_END_CUSTOMER_IN_INVENTORY_LIST,
      payload,
    });
  };

export const setSortOrder = sort => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.SET_END_CUSTOMER_IN_INVENTORY_LIST,
    payload: { sort },
  });
};

export const setListStore = newListState => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.SET_END_CUSTOMER_IN_INVENTORY_LIST,
    payload: newListState,
  });
};

export const resolve = async (id, req) => {
  return await datalayer.endCustomerInInventory.get({ id }, req);
};

export const get = (req, id) => dispatch => {
  return dispatch({
    type: ACTION_TYPES.FETCH_END_CUSTOMER_IN_INVENTORY,
    payload: datalayer.endCustomerInInventory.get({ id }, req),
  });
};

export const upsert = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.end-customer-in-inventory.upsert',
  });

export const upsertWhenEmpty = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.end-customer-in-inventory.upsertWhenEmpty',
  });

export const updateWhenEmpty = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.end-customer-in-inventory.updateWhenEmpty',
  });

export const update = actionParams =>
  getAxiosInstance().post('actions', {
    payload: actionParams,
    action: 'v1.end-customer-in-inventory.update',
  });
